import React from "react";
import { useForm } from "react-hook-form";
import { MUNICIPAL_CORPORATION_CONFIG_URL } from "../../../../api/api_routing_urls";
import useAuth from "../../../../authentication/hooks/useAuth";
import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import Button from "../../../../reusable-components/buttons/Button";
import SubmitButton from "../../../../reusable-components/buttons/SubmitButton";
import Input from "../../../../reusable-components/inputs/InputTextBox/Input";
import { button, cancel_button } from "../../../../theme/lightTheme";
import showToast from "../../../../utilities/notification/NotificationModal";

const AddMunicipalCorporationForm = ({
  getMunicipalCorporationList,
  editMunicipalCorporationDetails,
  setEditMunicipalCorporationDetails,
  setShowAddForm,
}) => {
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth();

  const isEdit = Object.keys(editMunicipalCorporationDetails)?.length > 0;

  const defaultValues = {
    municipalcorporationname: !isEdit
      ? ""
      : editMunicipalCorporationDetails?.municipalcorporationname,
  };
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
    reset,
    setValue,
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
    criteriaMode: "all",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  const controller = new AbortController();

  const onSubmit = async (data) => {
    try {
      let response = "";
      if (!isEdit) {
        data.createdby = auth.userid;
        response = await axiosPrivate.post(
          MUNICIPAL_CORPORATION_CONFIG_URL,
          data,
          {
            signal: controller.signal,
          }
        );
      } else {
        data.updatedby = auth.userid;
        data.municipalcorporationid =
          editMunicipalCorporationDetails?.municipalcorporationid;
        response = await axiosPrivate.put(
          MUNICIPAL_CORPORATION_CONFIG_URL,
          data,
          {
            signal: controller.signal,
          }
        );
      }
      if (response.status === 200) {
        if (isEdit) {
          setEditMunicipalCorporationDetails({});
          showToast(
            "Municipal Corporation has been updated successfully",
            "success"
          );
        } else {
          showToast(
            "Municipal Corporation has been added successfully",
            "success"
          );
        }
        getMunicipalCorporationList();
      } else {
        if (isEdit) {
          if (
            response.data.updateMunicipalCorporationDetails.includes(
              "unique_municipalcorporation"
            )
          ) {
            showToast(
              "Municipal Corporation already exists. Cannot insert duplicate municipal corporation",
              "error"
            );
          } else {
            showToast(
              "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
              "error"
            );
          }
        } else {
          if (
            response.data.saveMunicipalCorporationDetails.includes(
              "unique_municipalcorporation"
            )
          ) {
            showToast(
              "Municipal Corporation already exists. Cannot insert duplicate Municipal Corporation",
              "error"
            );
          } else {
            showToast(
              "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
              "error"
            );
          }
        }
        return;
      }
      setShowAddForm(false);
      reset();
    } catch (error) {
      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error"
        );
      }
    }
  };

  return (
    <section>
      {" "}
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          defaultName="municipalcorporationname"
          register={register}
          name="Municipal Corporation Name"
          required={true}
          pattern={null}
          errors={errors}
          placeholder="Enter municipal corporation name"
          setError={setError}
          clearError={clearErrors}
          autoComplete="off"
          type="text"
          classes={`rounded-lg px-3 py-2 text-sm w-full`}
          onChangeInput={null}
          defaultValue={defaultValues.municipalcorporationname}
          setValue={setValue}
        />
        <div className="flex justify-between">
          <SubmitButton
            isSubmitting={isSubmitting}
            label={!isEdit ? "Submit" : "Update"}
            className={button}
          />
          <Button
            onClick={() => {
              setEditMunicipalCorporationDetails({});
              setValue("municipalcorporationname", "");
              setShowAddForm(false);
            }}
            aria-label="Cancel Municipal Corporation Update Button"
            className={cancel_button}
          >
            Cancel
          </Button>
        </div>
      </form>
    </section>
  );
};

export default AddMunicipalCorporationForm;
